<template>
  <div class="add-purchase__course-detail">
    <div class="course-detail__card">
      <div class="add-purchase__course-detail__left">
        <p class="add-purchase__course-detail__left__title">
          <span
            class="add-purchase__course-detail__subject"
            v-if="courseInfoModule.subjects && courseInfoModule.subjects[0]"
          >
            {{courseInfoModule.subjects[0].name}}
          </span>
          {{ xss(courseInfoModule.courseName) }}
        </p>
        <Teacher
         v-if="Object.keys(courseDetail.teacherModule).length"
         :teacherModule="courseDetail.teacherModule"/>
        <!-- 主讲老师 -->
        <!-- <div
          class="teacher-item clear"
          v-if="courseDetail.chineseTeacher && courseDetail.chineseTeacher[0]"
        >
          <div
            class="teacher-item__avatar"
            :style="{
              backgroundImage: `url(${courseDetail.chineseTeacher[0].avatars[0]})`
            }"
          ></div>
          <div class="teacher-item__info">
            <p class="teacher-item__info__job-title">
              {{ courseDetail.chineseTeacher[0].typeName }}
            </p>
            <p class="teacher-item__info__name">
              {{
                courseDetail.chineseTeacher.length > 1
                  ? courseDetail.chineseTeacher[0].name + '等'
                  : courseDetail.chineseTeacher[0].name
              }}
            </p>
          </div>
        </div> -->
        <!-- 外交老师 -->
        <!-- <div
          class="teacher-item clear"
          v-if="
            courseDetail.foreignTeacher &&
              courseDetail.foreignTeacher[0] &&
              courseDetail.foreignTeacher[0].name &&
              courseDetail.foreignTeacher[0].typeName
          "
        >
          <div
            class="teacher-item__avatar"
            :style="{
              backgroundImage: `url(${courseDetail.foreignTeacher[0].avatars[0]} )`
            }"
          ></div>
          <div class="teacher-item__info">
            <p class="teacher-item__info__job-title">
              {{ courseDetail.foreignTeacher[0].typeName }}
            </p>
            <p class="teacher-item__info__name">
              {{ courseDetail.foreignTeacher[0].name }}
            </p>
          </div>
        </div> -->
        <!-- 辅导老师 -->
        <!-- <div
          class="teacher-item clear"
          v-if="
            courseDetail.isHaveCounselorTeacher === 1 &&
              courseDetail.class.counselor &&
              courseDetail.class.leftNum &&
              courseDetail.class.leftNum !== 0
          "
        >
          <div
            class="teacher-item__avatar"
            :style="{
              backgroundImage: `url(${courseDetail.class.counselor.avatars[0]})`
            }"
          ></div>
          <template
            v-if="courseDetail.excTeacherCourse && courseDetail.excTeacherCourse === 1"
          >
            <div class="teacher-item__info">
              <p class="teacher-item__info__job-title"></p>
              <p class="teacher-item__info__name">专属老师</p>
            </div>
          </template>
          <template v-else>
            <div class="teacher-item__info">
              <p class="teacher-item__info__job-title">
                {{ courseDetail.class.counselor.typeName }}
              </p>
              <p class="teacher-item__info__name">
                {{ courseDetail.class.counselor.name }}
              </p>
            </div>
            <div
              class="teacher-item__label"
              v-if="courseDetail.class.leftNum && courseDetail.class.leftNum !== 0"
            >
              余{{ courseDetail.class.leftNum }}名额
            </div>
          </template>
        </div> -->
      </div>
      <div class="add-purchase__course-detail__center">
        <p class="add-purchase__course-detail__left__time">
          {{ courseInfoModule.schooltimeName }}
        </p>
        <p
          class="add-purchase__course-detail__left__difficulty"
          v-if="courseInfoModule.difficulty.id && !/\D/.test(courseInfoModule.difficulty.alias)"
        >
          <span>难度：</span>
          <i
            v-for="index of Number(courseInfoModule.difficulty.alias)"
            :key="index"
            class="iconfont2 icon-star-fill"
          ></i>
        </p>
      </div>
      <div class="add-purchase__course-detail__right">
        <p
          class="add-purchase__course-detail__right__origin-price"
          v-if="Number(priceModule.price) !== Number(priceModule.resale)"
        >
          ￥{{ priceModule.price }}
        </p>
        <p class="add-purchase__course-detail__right__price">
          <strong>￥{{ priceModule.resale }}</strong>
        </p>
        <!-- <p class="add-purchase__course-detail__right__num">共{{courseDetail.syllabusNum}}讲</p> -->
      </div>
    </div>
    <div class="course-endTime" v-if="courseInfoModule.countDown">{{ courseInfoModule.countDown}}</div>
  </div>
</template>

<script>
import xss from 'xss'
// import calculateTime from '@/util/countDown'
import Teacher from './teacher.vue'

export default {
  props: {
    courseDetail: {
      type: Object,
      default:() => {}
    },
    courseInfoModule: {
      type: Object,
      default:() => {}
    },
    priceModule: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Teacher
  },
  data() {
    return {
      xss,
      countTime: null,
      timer: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
@include b(add-purchase) {
  min-width: 1200px;
  position: relative;
  @include e(course-detail) {
    background: #ffffff;
    position: relative;
    margin-bottom: 10px;
    @include e(left) {
      vertical-align: middle;
      display: inline-block;
      width: 378px;
      @include e(title) {
        color: #333333;
        font-size: 14px;
      }
      @include e(time) {
        color: #999999;
        font-size: 12px;
        margin-bottom: 6px;
        line-height: 20px;
        margin-top: 6px;
      }
      @include e(difficulty) {
        color: #999999;
        font-size: 12px;
        line-height: 24px;
        & > i {
          font-size: 12px;
          color: #666666;
        }
      }
    }
    @include e(subject) {
      box-sizing: border-box;
      background-color: transparent;
      color: #f13232;
      display: inline-block;
      min-width: 14px;
      font-size: 10px;
      line-height: 12px;
      text-align: center;
      border-radius: 2px;
      border: 1px solid #f13232;
    }
    @include e(center) {
      vertical-align: middle;
      width: 392px;
      display: inline-block;
      margin-right: 80px;
      margin-left: 100px;
    }
    @include e(right) {
      vertical-align: middle;
      width: 128px;
      display: inline-block;
      text-align: right;
      @include e(price) {
        font-size: 20px;
        color: #f13232;
        line-height: 28px;
      }
      @include e(origin-price) {
        font-size: 10px;
        color: #666666;
        text-decoration: line-through;
        line-height: 18px;
      }
      @include e(num) {
        height: 20px;
        line-height: 20px;
        color: #999999;
        font-size: 12px;
        // margin-bottom: 9px;
      }
    }
  }
}
.course-detail__card {
  padding: 22px 60px;
}

.course-endTime {
  height: 34px;
  line-height: 34px;
  color: #f07737;
  border-top: 1px #dcdcdc dotted;
  margin: 0 60px;
}
</style>



// WEBPACK FOOTER //
// ./src/views/AddPurchase/components/CourseDetail.vue